import { fetchProductPickUpConditions } from 'src/libs/api/orderApi';
import { fetchProductDetailById } from 'src/libs/api/productsApi';
import type { CartItem } from 'src/models/orderLimits/schema';
import type { LOCALE_TYPE } from 'src/types/locale';
import { getCartFromCookie } from 'src/utils/cookies';

export const getUnLoggedInCart = async (currentShopId: number, productsInCart: CartItem[], locale: LOCALE_TYPE) => {
  if (productsInCart.length === 0) return [];
  const pickUpConditions = await fetchProductPickUpConditions(
    currentShopId,
    productsInCart.map((productInCart) => productInCart.productId)
  );
  if (pickUpConditions.isLeft()) throw new Error(pickUpConditions.value.errors.join(','));

  const pickupConditionsMap = new Map(
    pickUpConditions.value.productPickupConditions.map(({ productId, earliestPickupDate }) => [
      parseInt(productId, 10),
      earliestPickupDate
    ])
  );

  const unLoggedInCartPromises = productsInCart.map(async ({ productId, quantity }) => {
    const product = await fetchProductDetailById(productId, locale);

    return product.isLeft()
      ? null
      : {
          product: product.value,
          orderLimit: product.value.orderLimit,
          date: pickupConditionsMap.get(productId),
          quantity
        };
  });
  const cartProducts = (await Promise.all(unLoggedInCartPromises)).filter((product) => !!product);
  return cartProducts.map(({ product, date, orderLimit, quantity }) => ({
    ...product,
    date,
    orderLimit,
    quantity
  }));
};

export const getLocalCartKey = (path: string) =>
  `${path}-${getCartFromCookie()
    .map((c) => `${c.productId}:${c.quantity}`)
    .join(',')}`;
